import { render, staticRenderFns } from "./askQues.vue?vue&type=template&id=c113efe6&scoped=true"
import script from "./askQues.vue?vue&type=script&lang=js"
export * from "./askQues.vue?vue&type=script&lang=js"
import style0 from "./askQues.vue?vue&type=style&index=0&id=c113efe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c113efe6",
  null
  
)

export default component.exports